(function () {
  if (window.tjmProductBound) return;
  window.tjmProductBound = true;

  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function motion() {
    return reduceQuery.matches ? 'auto' : 'smooth';
  }

  function embedUrl(src) {
    try {
      const url = new URL(src, window.location.origin);
      const host = url.hostname.replace(/^www\./, '');
      if (host === 'youtu.be') {
        const id = url.pathname.split('/').filter(Boolean)[0];
        return id ? 'https://www.youtube.com/embed/' + id + '?autoplay=1' : '';
      }
      if (host === 'youtube.com' || host === 'm.youtube.com') {
        const id = url.searchParams.get('v') || url.pathname.split('/').filter(Boolean).pop();
        return id ? 'https://www.youtube.com/embed/' + id + '?autoplay=1' : '';
      }
      if (host === 'vimeo.com' || host === 'player.vimeo.com') {
        const id = url.pathname.split('/').filter(Boolean).pop();
        return id ? 'https://player.vimeo.com/video/' + id + '?autoplay=1' : '';
      }
    } catch (error) {
      return '';
    }
    return '';
  }

  function syncGallery(gallery) {
    if (!gallery) return;
    const active = gallery.querySelector('.tjm-gallery__slide.is-active');
    const mediaId = active ? active.dataset.mediaId : '';
    const root = gallery.closest('.tjm-gallery') || gallery;
    root.querySelectorAll('.tjm-gallery__dot').forEach((dot) => {
      const on = dot.dataset.mediaId === mediaId;
      dot.classList.toggle('is-active', on);
      if (on) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    gallery.querySelectorAll('.tjm-gallery__thumb').forEach((thumb) => {
      const target = thumb.closest('[data-target]');
      const on = target && target.dataset.target === mediaId;
      if (on) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
    const currentThumb = gallery.querySelector('.tjm-gallery__thumb[aria-current="true"]');
    const list = gallery.querySelector('.tjm-gallery__thumb-list');
    const item = currentThumb ? currentThumb.closest('li') : null;
    if (!currentThumb || !list || !item || mobileQuery.matches) return;
    const top = item.offsetTop;
    const bottom = top + item.offsetHeight;
    if (top < list.scrollTop) {
      list.scrollTo({ top: top, behavior: motion() });
    } else if (bottom > list.scrollTop + list.clientHeight) {
      list.scrollTo({ top: bottom - list.clientHeight, behavior: motion() });
    }
  }

  function syncSticky(root) {
    if (!root || typeof root._tjmSyncSticky !== 'function') return;
    root._tjmSyncSticky();
  }

  function bindDialog(dialog) {
    if (!dialog || dialog.dataset.tjmBound === 'true') return;
    dialog.dataset.tjmBound = 'true';
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      const stage = dialog.querySelector('[data-tjm-video-stage]');
      if (stage) stage.replaceChildren();
    });
  }

  function openVideo(card) {
    const wrap = card.closest('[data-tjm-videos]');
    const dialog = wrap ? wrap.querySelector('[data-tjm-video-dialog]') : null;
    const stage = dialog ? dialog.querySelector('[data-tjm-video-stage]') : null;
    if (!dialog || !stage) return;
    bindDialog(dialog);
    stage.replaceChildren();
    const title = card.dataset.videoTitle || 'Video';
    const src = card.dataset.videoSrc || '';
    const embed = card.dataset.videoEmbed || embedUrl(src);
    if (embed) {
      const iframe = document.createElement('iframe');
      iframe.src = embed;
      iframe.title = title;
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      stage.appendChild(iframe);
    } else if (src) {
      const video = document.createElement('video');
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.src = src;
      video.setAttribute('aria-label', title);
      stage.appendChild(video);
    }
    if (!dialog.open) dialog.showModal();
  }

  function observeSticky(root) {
    const bar = root.querySelector('[data-tjm-sticky-atc]');
    const mainButton = root.querySelector('[data-tjm-atc]');
    const stickyButton = bar ? bar.querySelector('button') : null;
    if (!bar || !mainButton || !stickyButton) return;

    const syncLabel = () => {
      const label = mainButton.querySelector('span');
      if (label) stickyButton.textContent = label.textContent.trim();
      stickyButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
    };

    const apply = (visible) => {
      const show = mobileQuery.matches && !visible;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('tjm-sticky-atc-on', show);
    };

    const inView = () => {
      const rect = mainButton.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    };

    const observer = new IntersectionObserver(
      (entries) => {
        apply(entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(mainButton);
    mobileQuery.addEventListener('change', () => apply(inView()));
    syncLabel();
    root._tjmSyncSticky = syncLabel;
  }

  function setup(root) {
    if (!root || root.dataset.tjmReady === 'true') return;
    root.dataset.tjmReady = 'true';
    root.querySelectorAll('.tjm-gallery__slides').forEach((slides) => {
      slides.addEventListener(
        'scroll',
        () => {
          if (!mobileQuery.matches) return;
          const width = slides.clientWidth;
          if (!width) return;
          const index = Math.round(slides.scrollLeft / width);
          const items = slides.querySelectorAll('.tjm-gallery__slide');
          items.forEach((slide, itemIndex) => {
            slide.classList.toggle('is-active', itemIndex === index);
          });
          syncGallery(slides.closest('media-gallery'));
        },
        { passive: true }
      );
    });
    root.querySelectorAll('dialog').forEach(bindDialog);
    observeSticky(root);
  }

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('.tjm-gallery__thumb');
    if (thumb && !event.target.closest('[data-tjm-gallery-next]')) {
      window.requestAnimationFrame(() => syncGallery(thumb.closest('media-gallery')));
      return;
    }

    const next = event.target.closest('[data-tjm-gallery-next]');
    if (next) {
      const gallery = next.closest('media-gallery');
      const thumbs = gallery ? Array.from(gallery.querySelectorAll('.tjm-gallery__thumb')) : [];
      if (!thumbs.length) return;
      const current = gallery.querySelector('.tjm-gallery__thumb[aria-current="true"]');
      const index = Math.max(0, thumbs.indexOf(current));
      thumbs[(index + 1) % thumbs.length].click();
      window.requestAnimationFrame(() => syncGallery(gallery));
      return;
    }

    const dot = event.target.closest('[data-tjm-gallery-dot]');
    if (dot) {
      const gallery = dot.closest('.tjm-gallery');
      const mediaGallery = gallery ? gallery.querySelector('media-gallery') : null;
      const thumb = mediaGallery
        ? mediaGallery.querySelector('[data-target="' + dot.dataset.mediaId + '"] .tjm-gallery__thumb')
        : null;
      if (thumb) thumb.click();
      const slide = mediaGallery
        ? mediaGallery.querySelector('.tjm-gallery__slide[data-media-id="' + dot.dataset.mediaId + '"]')
        : null;
      if (slide && mobileQuery.matches) {
        slide.scrollIntoView({ inline: 'start', block: 'nearest', behavior: motion() });
      }
      window.requestAnimationFrame(() => syncGallery(mediaGallery));
      return;
    }

    const guide = event.target.closest('[data-tjm-size-guide]');
    if (guide) {
      const dialog = document.getElementById(guide.getAttribute('aria-controls'));
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    const close = event.target.closest('[data-tjm-dialog-close]');
    if (close) {
      const dialog = close.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    const video = event.target.closest('[data-tjm-video]');
    if (video) {
      openVideo(video);
      return;
    }

    const sticky = event.target.closest('[data-tjm-sticky-submit]');
    if (sticky) {
      const root = sticky.closest('product-info');
      const mainButton = root ? root.querySelector('[data-tjm-atc]') : null;
      if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
      mainButton.click();
      return;
    }

    const reviews = event.target.closest('[data-tjm-reviews]');
    if (reviews) {
      const id = (reviews.getAttribute('href') || '').replace('#', '');
      const target = id ? document.getElementById(id) : null;
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: motion(), block: 'start' });
    }
  });

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event && event.data ? event.data.sectionId : '';
      const root = document.querySelector('product-info[data-section="' + sectionId + '"]');
      if (!root) return;
      const gallery = root.querySelector('media-gallery');
      const dots = root.querySelector('.tjm-gallery__dots');
      if (gallery && dots) {
        gallery.querySelectorAll('.tjm-gallery__slide').forEach((slide) => {
          const dot = dots.querySelector('[data-media-id="' + slide.dataset.mediaId + '"]');
          if (dot) dots.appendChild(dot);
        });
        syncGallery(gallery);
      }
      const rewards = root.querySelector('[data-tjm-rewards]');
      const variant = event.data ? event.data.variant : null;
      if (rewards && variant && variant.price != null) {
        const multiplier = Number(rewards.dataset.multiplier) || 0;
        const points = Math.round((Number(variant.price) / 100) * multiplier);
        const template = rewards.dataset.template || '';
        rewards.textContent = template.split('{points}').join(String(points));
      }
      syncSticky(root);
    });
  }

  function boot(scope) {
    const nodes = scope.querySelectorAll
      ? scope.querySelectorAll('product-info[data-tjm-product]')
      : [];
    nodes.forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:unload', () => {
    document.body.classList.remove('tjm-sticky-atc-on');
  });
  document.addEventListener('product-info:loaded', (event) => {
    const root = event.target && event.target.matches && event.target.matches('product-info')
      ? event.target
      : event.target.closest('product-info');
    if (root && root.hasAttribute('data-tjm-product')) setup(root);
  });
})();
